export default {
    name: 'badge',

    props: {
        red: Boolean,
        orange: Boolean,
        green: Boolean,
        purple: Boolean,
        secondaryIcon: Boolean,
        points: Number,
        label: String,
        icon: String,
        color: String,
        small:Boolean,
        noBackface:Boolean,
        grey: String,
    },

    computed: {
        classes() {
            return {
                'red': this.red || this.color == 'red',
                'grey': this.grey || this.colour == 'grey',
                'orange': this.orange || this.color == 'orange',
                'green': this.green || this.color == 'green',
                'purple': this.purple || this.color == 'purple',
                'yellow': this.purple || this.color == 'yellow',
                'secondary-icon': this.secondaryIcon,
                'badge--small': this.small,
                'badge--no-backface': this.noBackface
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/badge/badge.js